export enum PaperBagsWithHandlesFields {
  type = "type",
  width = "width",
  length = "length",
  folding = "folding",
  mainColor = "mainColor",
  otherMainColor = "otherMainColor",
  printColors = "printColors",
  printArea = "printArea",
  printColorsBack = "printColorsBack",
  printAreaBack = "printAreaBack",
  designFile = "designFile",
  amountPcs = "amountPcs",
}
